<div class="flex flex-column gap-4">
  <form [formGroup]="completeProfileForm" (ngSubmit)="continue()" validateOnSubmit>
    <div class="container_width flex flex-column sm:flex-row align-items-center gap-1 w-full">
      <div
        class="flex sm:flex-1 w-full  align-items-center justify-content-center p-2 border-round-3xl sm:border-noround-right"
        [ngClass]="currentStep === steps.demography ? 'bg-bluegray-100 gradient_top' : 'bg-bluegray-300'">
        <p class="font-medium text-sm">Demographics</p>
      </div>
      <div
        class="flex sm:flex-1 w-full align-items-center justify-content-center p-2 border-round-3xl sm:border-noround "
        [ngClass]="currentStep === steps.testscore ? 'bg-bluegray-100 gradient_top' : currentStep<steps.testscore?'bg-bluegray-100':'bg-bluegray-300'">
        <p class="font-medium text-sm">Test Scores</p>
      </div>
      <div
        class="flex sm:flex-1 w-full align-items-center justify-content-center p-2 border-round-3xl sm:border-noround"
        [ngClass]="currentStep === steps.grades ? 'bg-bluegray-100 gradient_top' : currentStep<steps.grades?'bg-bluegray-100':'bg-bluegray-300'">
        <p class="font-medium text-sm">Grades</p>
      </div>
      <div
        class="flex sm:flex-1 w-full align-items-center justify-content-center p-2 border-round-3xl sm:border-noround"
        [ngClass]="currentStep === steps.coursework ? 'bg-bluegray-100 gradient_top' : currentStep<steps.coursework?'bg-bluegray-100':'bg-bluegray-300'">
        <p class="font-medium text-sm">Coursework</p>
      </div>
      <div
        class="flex sm:flex-1 w-full align-items-center justify-content-center p-2 border-round-3xl sm:border-noround-left"
        [ngClass]="currentStep === steps.extracurricular ? 'bg-bluegray-100 gradient_top' : currentStep<steps.extracurricular?'bg-bluegray-100':'bg-bluegray-300'">
        <p class="font-medium text-sm">Experiences</p>
      </div>
    </div>
    <div class="flex-column gap-4 my-5" [ngClass]="{ 'hidden': currentStep != steps.demography }">
      <div class="w-full py-5 yellow_color flex align-items-center justify-content-center">
        <div class="w-full complete_width">
          <h1 class="font-medium text-3xl text-gray-900">Demographics</h1>
        </div>
      </div>
      <div class="w-full complete_width mx-auto flex flex-column gap-5 pt-5" formGroupName="demography">
        <div class="flex flex-column gap-2">
          <b class="w-full text-left font-medium text-gray-800 text-base">Home Country <span
              class="text-red-500 text-xl">*</span></b>
          <p-dropdown [options]="countries" styleClass="full-width"
            [ngClass]="{'ng-invalid ng-dirty' : submitted && ! completeProfileForm.get('demography.homeCountry').value}"
            optionLabel="name" optionValue="countryCode" formControlName="homeCountry" [filter]="true" filterBy="name"
            [showClear]="true" appendTo="body" placeholder="Select a Country" (onChange)="loadCitiesByCountry()">
            <ng-template pTemplate="selectedItem" let-selectedOption>
              <div class="flex align-items-center gap-2">
                <div>{{ selectedOption.name }}</div>
              </div>
            </ng-template>
            <ng-template let-country pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ country.name }}</div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">City
            <span class="text-red-500 text-xl">*</span>
          </b>
          <div class="flex flex-column gap-2">
            <p-autoComplete [suggestions]="filteredCities" formControlName="homeCity" placeholder="Type to search a city"
            [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('demography.homeCity')?.value}"
            (completeMethod)="filterCities($event)" styleClass="full-width" [showClear]="true" [forceSelection]="true"> 
            </p-autoComplete>
            <small class="ng-dirty ng-invalid text-red-500"
              *ngIf="completeProfileForm.get('demography.homeCity')?.invalid && (submitted || completeProfileForm.get('demography.homeCity')?.touched)">
              City is required
            </small>
          </div>
        </div>
        <div class="flex flex-column gap-2">
          <b class="w-full text-left font-medium text-gray-800 text-base">Which country are you planning to apply
            to?<span class="text-red-500 text-xl">*</span></b>
          <p-multiSelect [options]="destinationCountries"
            [ngClass]="{'ng-invalid ng-dirty' : submitted && ! completeProfileForm.get('demography.destination').value}"
            optionLabel="label" optionValue="value" formControlName="destination" styleClass="full-width"
            placeholder="Select Countries">
            <ng-template let-value pTemplate="selectedItems">
              <div class="inline-flex align-items-center gap-2 px-1" *ngFor="let option of value">
                <img [src]="option.icon" [class]="'flag flag-' + option.value.toLowerCase()" style="width: 18px" />
                <div>{{ option.label }},</div>
              </div>
              <div *ngIf="!value || value.length === 0">Select Countries</div>
            </ng-template>
            <ng-template let-country pTemplate="item">
              <div class="flex align-items-center gap-2">
                <img [src]="country.icon" [class]="'flag flag-' + country.value.toLowerCase()" style="width: 18px" />
                <div>{{ country.label }}</div>
              </div>
            </ng-template>
          </p-multiSelect>
          <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('demography.destination').invalid &&
          (submitted || completeProfileForm.get('demography.destination').touched)">
            Select Country
          </small>
        </div>
        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">Which degree do you wish to pursue?<span
              class="text-red-500 text-xl">*</span></b>
          <div class="flex flex-column gap-2">
            <div *ngFor="let item of degreePrefs" class="flex align-items-center">
              <p-radioButton [inputId]="item.name" formControlName="degreePreference" [value]="item.key"
                [ngClass]="{'ng-invalid ng-dirty' : submitted && ! completeProfileForm.get('demography.degreePreference').value}"
                styleClass="radio" />
              <label [for]="item.name" class="ml-2">
                {{ item.name }}
              </label>
            </div>
            <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('demography.degreePreference').invalid &&
          (submitted || completeProfileForm.get('demography.degreePreference').touched)">
              Which degree do you wish to pursue is required
            </small>
          </div>
        </div>

        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">High school
            <span class="text-red-500 text-xl">*</span>
          </b>

          <!-- High School Name Input, shown only if 'highSchoolNameisNotListed' is not checked -->
          <div class="flex flex-column gap-2" *ngIf="!demography?.highSchoolNameisNotListed"
            >
            <!-- <p-autoComplete formControlName="highSchoolName" [suggestions]="places"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('demography.highSchoolName')?.value}"
              (completeMethod)="filterPlaces($event)" styleClass="full-width" optionValue="name"
              (onSelect)="onHighSchoolNameSelection()" optionLabel="name">
            </p-autoComplete> -->
            <input pInputText styleClass="full-width" formControlName="highSchoolName" placeholder="Name"
            [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('demography.highSchoolName')?.value}" />
            <small class="ng-dirty ng-invalid text-red-500"
              *ngIf="completeProfileForm.get('demography.highSchoolName')?.invalid && (submitted || completeProfileForm.get('demography.highSchoolName')?.touched)">
              High school is required
            </small>
          </div>

          <!-- High School Not Listed Checkbox, shown if 'highSchoolName' is empty or not selected -->
          <div
            *ngIf="!completeProfileForm.get('demography.highSchoolName')?.value || demography?.highSchoolNameisNotListed"
            class="flex flex-column gap-2">
            <div>
              <p-checkbox formControlName="highSchoolNameisNotListed" binary="true" inputId="background"
                (onChange)="onhighSchoolNameisNotListedChange()" styleClass="radio">
              </p-checkbox>
              <label for="background" class="ml-2 font-normal text-gray-700">
                My high school is not listed, or I have a non-traditional educational background
              </label>
            </div>
            <small class="ng-dirty ng-invalid text-red-500"
              *ngIf="completeProfileForm.get('demography.highSchoolNameisNotListed')?.invalid && (submitted || completeProfileForm.get('demography.highSchoolNameisNotListed')?.touched)">
              High school is required
            </small>
          </div>
        </div>
        <!-- HERE -->
        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">Stream in high school?</b>
          <input pInputText styleClass="full-width" formControlName="highSchoolStream" placeholder="Stream" /> 
          <small class="ng-dirty ng-invalid text-red-500"
              *ngIf="completeProfileForm.get('demography.highSchoolStream')?.invalid && (submitted || completeProfileForm.get('demography.highSchoolStream')?.touched)">
              High school stream is required
            </small>
        </div>

        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">High school start date?</b>
          <p-calendar [showIcon]="true" [iconDisplay]="'input'" inputId="iconDisplay"
          appendTo="body" styleClass="full-width" formControlName="highSchoolStartDate" />   
          <small class="ng-dirty ng-invalid text-red-500"
              *ngIf="completeProfileForm.get('demography.highSchoolStartDate')?.invalid && (submitted || completeProfileForm.get('demography.highSchoolStartDate')?.touched)">
              High school start date is required
            </small>
        </div>

        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">High school end date?</b>
          <p-calendar [showIcon]="true" [iconDisplay]="'input'" inputId="iconDisplay"
          appendTo="body" styleClass="full-width" formControlName="highSchoolEndDate" />  
          <small class="ng-dirty ng-invalid text-red-500"
              *ngIf="completeProfileForm.get('demography.highSchoolEndDate')?.invalid && (submitted || completeProfileForm.get('demography.highSchoolEndDate')?.touched)">
              High school end date is required
            </small> 
        </div>

        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">Which is the highest level of education you
            have attained?<span class="text-red-500 text-xl">*</span></b>
          <div class="flex flex-column gap-2">
            <div *ngFor="let item of heightestEducationAttained" class="flex align-items-center">
              <p-radioButton [inputId]="item.key" [value]="item.key" formControlName="highestLevelEducation"
                [ngClass]="{'ng-invalid ng-dirty' : submitted && ! completeProfileForm.get('demography.highestLevelEducation').value}"
                styleClass="radio" />
              <label [for]="item.key" class="ml-2">
                {{ item.name }}
              </label>
            </div>
            <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('demography.highestLevelEducation').invalid &&
          (submitted || completeProfileForm.get('demography.highestLevelEducation').touched)">
              Which is the highest level of education you have attained is required
            </small>
          </div>
        </div>

        <div *ngIf="completeProfileForm.get('demography.highestLevelEducation').value === 'Undergraduate degree' || completeProfileForm.get('demography.highestLevelEducation').value === 'Post Graduate degree'" >
          <div class="flex flex-column gap-3">
            <b class="w-full text-left font-medium text-gray-800 text-base">Undergraduate university name?</b>
            <p-autoComplete [suggestions]="institutes" [showClear]="true" (completeMethod)="filterInstitutes($event)" optionLabel="name"
            styleClass="full-width" formControlName="underGraduateCollageName" placeholder="University Name" optionValue="name"/> 
            <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="completeProfileForm.get('demography.underGraduateCollageName')?.invalid && (submitted || completeProfileForm.get('demography.underGraduateCollageName')?.touched)">
                University Name is required
              </small>
          </div>

          <div class="flex flex-column gap-3">
            <b class="w-full text-left font-medium text-gray-800 text-base">Undergraduate Major/Degree name?</b>
            <input pInputText styleClass="full-width" formControlName="underGraduateMajorOrDegree" placeholder="Major or Degree" /> 
            <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="completeProfileForm.get('demography.underGraduateMajorOrDegree')?.invalid && (submitted || completeProfileForm.get('demography.underGraduateMajorOrDegree')?.touched)">
                Undergraduate Major/Degree is required
              </small>
          </div>

          <div class="flex flex-column gap-3">
            <b class="w-full text-left font-medium text-gray-800 text-base">Undergraduate field of study name?</b>
            <input pInputText styleClass="full-width" formControlName="underGraduateFieldOfStudy" placeholder="Field of study" /> 
            <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="completeProfileForm.get('demography.underGraduateFieldOfStudy')?.invalid && (submitted || completeProfileForm.get('demography.underGraduateFieldOfStudy')?.touched)">
                Undergraduate field of study is required
              </small>
          </div>

          <div class="flex flex-column gap-3">
            <b class="w-full text-left font-medium text-gray-800 text-base">Undergraduate start date?</b>
            <p-calendar [showIcon]="true" [iconDisplay]="'input'" inputId="iconDisplay"
            appendTo="body" styleClass="full-width" formControlName="underGraduateStartDate" />   
            <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="completeProfileForm.get('demography.underGraduateStartDate')?.invalid && (submitted || completeProfileForm.get('demography.underGraduateStartDate')?.touched)">
                UnderGraduate start date is required
              </small>
          </div>

          <div class="flex flex-column gap-3">
            <b class="w-full text-left font-medium text-gray-800 text-base">Undergraduate end date?</b>
            <p-calendar [showIcon]="true" [iconDisplay]="'input'" inputId="iconDisplay"
            appendTo="body" styleClass="full-width" formControlName="underGraduateEndDate" />   
            <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="completeProfileForm.get('demography.underGraduateEndDate')?.invalid && (submitted || completeProfileForm.get('demography.underGraduateEndDate')?.touched)">
                UnderGraduate end date is required
              </small>
          </div>
        </div>

        <div *ngIf="completeProfileForm.get('demography.highestLevelEducation').value === 'Post Graduate degree'">
          <div class="flex flex-column gap-3">
            <b class="w-full text-left font-medium text-gray-800 text-base">Graduate university name?</b>
            <p-autoComplete [suggestions]="institutes" [showClear]="true" (completeMethod)="filterInstitutes($event)" optionLabel="name"
            styleClass="full-width" formControlName="graduateCollageName" placeholder="University Name" optionValue="name"/> 
            <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="completeProfileForm.get('demography.graduateCollageName')?.invalid && (submitted || completeProfileForm.get('demography.graduateCollageName')?.touched)">
                University Name is required
              </small>
          </div>

          <div class="flex flex-column gap-3">
            <b class="w-full text-left font-medium text-gray-800 text-base">Graduate Major/Degree name?</b>
            <input pInputText styleClass="full-width" formControlName="graduateMajorOrDegree" placeholder="Major or Degree" /> 
            <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="completeProfileForm.get('demography.graduateMajorOrDegree')?.invalid && (submitted || completeProfileForm.get('demography.graduateMajorOrDegree')?.touched)">
                Graduate Major/Degree is required
              </small>
          </div>

          <div class="flex flex-column gap-3">
            <b class="w-full text-left font-medium text-gray-800 text-base">Graduate field of study name?</b>
            <input pInputText styleClass="full-width" formControlName="graduateFieldOfStudy" placeholder="Field of study" /> 
            <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="completeProfileForm.get('demography.graduateFieldOfStudy')?.invalid && (submitted || completeProfileForm.get('demography.graduateFieldOfStudy')?.touched)">
                  Graduate field of study is required
              </small>
          </div>

          <div class="flex flex-column gap-3">
            <b class="w-full text-left font-medium text-gray-800 text-base">Graduate degree start date?</b>
            <p-calendar [showIcon]="true" [iconDisplay]="'input'" inputId="iconDisplay"
            appendTo="body" styleClass="full-width" formControlName="graduateStartDate" />   
            <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="completeProfileForm.get('demography.graduateStartDate')?.invalid && (submitted || completeProfileForm.get('demography.graduateStartDate')?.touched)">
                Graduate start date is required
              </small>
          </div>

          <div class="flex flex-column gap-3">
            <b class="w-full text-left font-medium text-gray-800 text-base">Graduate degree end date?</b>
            <p-calendar [showIcon]="true" [iconDisplay]="'input'" inputId="iconDisplay"
            appendTo="body" styleClass="full-width" formControlName="graduateEndDate" />   
            <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="completeProfileForm.get('demography.graduateEndDate')?.invalid && (submitted || completeProfileForm.get('demography.graduateEndDate')?.touched)">
                Graduate end date is required
              </small>
          </div>
        </div>

        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">Applying as international or do you have
            residence rights?<span class="text-red-500 text-xl">*</span></b>
          <div class="flex flex-column gap-2">
            <div *ngFor="let item of applyingAs" class="flex align-items-center">
              <p-radioButton [inputId]="item.key" formControlName="applyingAs"
                [ngClass]="{'ng-invalid ng-dirty' : submitted && ! completeProfileForm.get('demography.applyingAs').value}"
                [value]="item.key" styleClass="radio" />
              <label [for]="item.key" class="ml-2">
                {{ item.name }}
              </label>
            </div>
            <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('demography.applyingAs').invalid &&
          (submitted || completeProfileForm.get('demography.applyingAs').touched)">
              Applying as international or do you have residence rights is required
            </small>
          </div>
        </div>

        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">Gender <span
              class="text-red-500 text-xl">*</span></b>
          <div class="flex flex-column gap-2">
            <div class="flex flex-column gap-2">
              <div *ngFor="let item of genders" class="flex align-items-center">
                <p-radioButton [inputId]="item.name" formControlName="gender" [value]="item.value"
                  [ngClass]="{'ng-invalid ng-dirty' : submitted && ! completeProfileForm.get('demography.gender').value}"
                  styleClass="radio" />
                <label [for]="item.name" class="ml-2">
                  {{ item.name }}
                </label>
              </div>
              <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('demography.gender').invalid &&
            (submitted || completeProfileForm.get('demography.gender').touched)">
                Gender is required
              </small>
            </div>
          </div>
        </div>

        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">Are you planning to apply for financial
            aid?<span class="text-red-500 text-xl">*</span></b>
          <div class="flex flex-column gap-2">
            <div *ngFor="let item of financialAidPlans" class="flex align-items-center">
              <p-radioButton [inputId]="item.name" formControlName="financialAid"
                [ngClass]="{'ng-invalid ng-dirty' : submitted && ! completeProfileForm.get('demography.financialAid').value}"
                [value]="item" [value]="item.key" styleClass="radio" />
              <label [for]="item.name" class="ml-2">
                {{ item.name }}
              </label>
            </div>
            <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('demography.financialAid').invalid &&
          (submitted || completeProfileForm.get('demography.financialAid').touched)">
              Are you planning to apply for financial aid is required
            </small>
          </div>
        </div>

        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">What is the maximum amount that your family
            can spend on college each year?</b>
          <p-inputNumber styleClass="full-width" formControlName="familySpendingAbility" mode="currency" currency="USD"
            currencyDisplay="code" locale="en-US" />
        </div>

        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">What is your family’s household income?</b>
          <p-inputNumber styleClass="full-width" formControlName="householdIncome" mode="currency" currency="USD"
            currencyDisplay="code" locale="en-US" />
        </div>

        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">Intended major</b>
          <p-autoComplete [suggestions]="majors" [forceSelection]="true" formControlName="intendedMajor" placeholder="Select a Major"
          (completeMethod)="filterIntendedMajors($event)" styleClass="full-width">
            <!-- <ng-template let-groupitem pTemplate="group">
              <div class="flex align-items-center">
                <span>{{ groupitem.group }}</span>
              </div>
            </ng-template>
            <ng-template let-item pTemplate="item">
              <div>
                <span class="ml-3">{{ item.label }}</span>
              </div>
            </ng-template> -->
          </p-autoComplete>
        </div>

        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">Legacy relationship</b>
          <div class="flex flex-column gap-2">
            <div class="flex align-items-center">
              <p-radioButton #isLegacyRelationshipYes inputId="isLegacyRelationshipYes"
                formControlName="isLegacyRelationship" [value]="true" styleClass="radio" />
              <label for="isLegacyRelationshipYes" class="ml-2 font-medium text-gray-700">
                Yes, my parents have graduated from a university abroad
              </label>
            </div>
            <div class="flex align-items-center">
              <p-radioButton inputId="isLegacyRelationshipNo" formControlName="isLegacyRelationship" [value]="false"
                styleClass="radio" />
              <label for="isLegacyRelationshipNo" class="ml-2 font-medium text-gray-700">
                No, my parents have not graduated from a university abroad
              </label>
            </div>
          </div>
        </div>

        <div class="flex flex-column gap-2" *ngIf="isLegacyRelationshipYes.checked || demography?.isLegacyRelationship">
          <b class="w-full text-left font-medium text-gray-800 text-base">If you have one or more parent/guardian who
            completed a 4-year bachelor’s degree, which school(s) did they graduate from? <span
              class="text-sm text-gray-500">(optional)</span></b>
          <p-autoComplete formControlName="parentsGraduationSchool" [suggestions]="institutes"
            (completeMethod)="filterInstitutes($event)" styleClass="full-width" optionValue="name" optionLabel="name">
          </p-autoComplete>
        </div>
      </div>
    </div>

    <div class="flex-column gap-4 my-5" [ngClass]="{ 'hidden': currentStep != steps.testscore }">
      <div class="w-full py-5 yellow_color flex align-items-center justify-content-center">
        <div class="w-full complete_width">
          <h1 class="font-medium text-3xl text-gray-900">Test Scores</h1>
        </div>
      </div>
      <div class="w-full complete_width mx-auto flex flex-column gap-5 pt-5" formGroupName="testScoreForm">
        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">
            Which standardized test scores do you have? <span class="text-red-500 text-xl">*</span>
          </b>
          <div class="flex flex-column gap-2">
            <div class="flex flex-column gap-2">
              <p-checkbox formControlName="satScoreCheck" [binary]="true" label="SAT" name="SAT" styleClass="checkbox"
                (onChange)="onTestCheckboxChange()"></p-checkbox>
              <div *ngIf="completeProfileForm.get('testScoreForm.satScoreCheck').value">
                <div class="w_50 mb-2">
                  <p-inputNumber styleClass="input-number" class="w-full"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('testScoreForm.satScores')?.value}"
                    formControlName="satScores" inputId="locale-user" placeholder="Add composite score"
                    [minFractionDigits]="2"></p-inputNumber>
                </div>
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('testScoreForm.satScores').invalid &&
              (submitted || completeProfileForm.get('testScoreForm.satScores').touched)">
                  SAT Score is required
                </small>
              </div>
            </div>

            <div class="flex flex-column gap-2">
              <p-checkbox formControlName="actScoresCheck" [binary]="true" label="ACT" name="ACT" styleClass="checkbox"
                (onChange)="onTestCheckboxChange()"></p-checkbox>
              <div *ngIf="completeProfileForm.get('testScoreForm.actScoresCheck').value">
                <div class="w_50 mb-2">
                  <p-inputNumber styleClass="input-number" class="w-full"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('testScoreForm.actScores')?.value}"
                    formControlName="actScores" inputId="locale-user" placeholder="Add composite score"
                    [minFractionDigits]="2"></p-inputNumber>
                </div>
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('testScoreForm.actScores').invalid &&
              (submitted || completeProfileForm.get('testScoreForm.actScores').touched)">
                  ACT Score is required
                </small>
              </div>
            </div>

            <div class="flex flex-column gap-2">
              <p-checkbox formControlName="greScoresCheck" [binary]="true" label="GRE" name="GRE" styleClass="checkbox"
                (onChange)="onTestCheckboxChange()"></p-checkbox>
              <div *ngIf="completeProfileForm.get('testScoreForm.greScoresCheck').value">
                <div class="w_50 mb-2">
                  <p-inputNumber styleClass="input-number" class="w-full"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('testScoreForm.greScores')?.value}"
                    formControlName="greScores" inputId="locale-user" placeholder="Add composite score"
                    [minFractionDigits]="2"></p-inputNumber>
                </div>
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('testScoreForm.greScores').invalid &&
              (submitted || completeProfileForm.get('testScoreForm.greScores').touched)">
                  GRE Score is required
                </small>
              </div>
            </div>

            <div class="flex flex-column gap-2">
              <p-checkbox formControlName="gmatScoresCheck" [binary]="true" label="GMAT" name="GMAT"
                styleClass="checkbox" (onChange)="onTestCheckboxChange()"></p-checkbox>
              <div *ngIf="completeProfileForm.get('testScoreForm.gmatScoresCheck').value">
                <div class="w_50 mb-2">
                  <p-inputNumber styleClass="input-number" class="w-full"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('testScoreForm.gmatScores')?.value}"
                    formControlName="gmatScores" inputId="locale-user" placeholder="Add composite score"
                    [minFractionDigits]="2"></p-inputNumber>
                </div>
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('testScoreForm.gmatScores').invalid &&
                (submitted || completeProfileForm.get('testScoreForm.gmatScores').touched)">
                  GMAT Score is required
                </small>
              </div>
            </div>
            <div class="flex flex-column gap-2">
              <p-checkbox formControlName="isStanardizedTestNotGiven" [binary]="true"
                label="I haven’t taken any test yet" styleClass="checkbox"
                (onChange)="onNoStandardisedTestGivenChange($event)" />
            </div>
          </div>
          <!-- Validation Message -->
          <small class="ng-dirty ng-invalid text-red-500" *ngIf="!(completeProfileForm.get('testScoreForm.satScoreCheck').value
                   || completeProfileForm.get('testScoreForm.actScoresCheck').value
                   || completeProfileForm.get('testScoreForm.greScoresCheck').value
                   || completeProfileForm.get('testScoreForm.gmatScoresCheck').value
                   || completeProfileForm.get('testScoreForm.isStanardizedTestNotGiven').value) &&
                   submitted">
            Please select one of the options
          </small>
        </div>

        <div class="flex flex-column gap-2">
          <b class="w-full text-left font-medium text-gray-800 text-base">AP Exams</b>
          <div class="flex flex-column gap-3" formArrayName="apExams">
            <div *ngFor="let exam of apExams.controls; let i = index" [formGroupName]="i"
              class="w-full mb-2 flex flex-column gap-2">
              <div class="grid ">
                <div class="flex-1 flex flex-column gap-2 col-5">
                  <b class="text-sm font-normal text-gray-600">Subject Name</b>
                  <input [ngClass]="{'ng-invalid ng-dirty': submitted && !exam.get('subjectName')?.value}" type="text"
                    formControlName="subjectName" pInputText class="w-full" />
                  <small class="text-red-500" *ngIf="exam.get('subjectName')?.invalid &&
                (submitted || exam.get('subjectName')?.touched)">
                    Subject Name is required
                  </small>
                </div>

                <div class="flex-1 flex flex-column gap-2 col-5">
                  <b class="text-sm font-normal text-gray-600">Subject Score</b>
                  <p-inputNumber styleClass="input-number" class="w-full"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !exam.get('subjectScore')?.value}"
                    formControlName="subjectScore" inputId="locale-user" [minFractionDigits]="2"></p-inputNumber>
                  <small class="text-red-500" *ngIf="exam.get('subjectScore')?.invalid &&
                (submitted || exam.get('subjectScore')?.touched)">
                    Subject Score is required
                  </small>
                </div>
                <div class="flex justify-content-center align-items-end col-2 pb-3">
                  <p-button icon="pi pi-times" styleClass="closeIcon" [rounded]="true" severity="secondary"
                    (onClick)="removeAPExam(i)" />
                </div>
              </div>
            </div>
            <div class="flex justify-content-end">
              <p-button label="Add More" icon="pi pi-plus" (onClick)="addAPExam()" styleClass="addmore" />
            </div>
          </div>
        </div>

        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">
            English language proficiency test <span class="text-red-500 text-xl">*</span>
          </b>
          <div class="flex flex-column gap-2">
            <div class="flex flex-column gap-2">
              <p-checkbox [binary]="true" formControlName="toeflScoresCheck" label="TOEFL" name="TOEFL" value="TOEFL"
                styleClass="checkbox" (onChange)="onEnglishTestCheckboxChange()" />
              <div *ngIf="completeProfileForm.get('testScoreForm.toeflScoresCheck').value">
                <div class="w_50 mb-2">
                  <p-inputNumber styleClass="input-number" class="w-full"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('testScoreForm.toeflScores')?.value}"
                    (onChange)="onEnglishTestCheckboxChange()" formControlName="toeflScores" inputId="locale-user"
                    placeholder="Add composite score" [minFractionDigits]="2" />
                </div>
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('testScoreForm.toeflScores').invalid &&
              (submitted || completeProfileForm.get('testScoreForm.toeflScores').touched)">
                  TOEFL Score is required
                </small>
              </div>
            </div>
            <div class="flex flex-column gap-2">
              <p-checkbox [binary]="true" formControlName="ieltsScoresCheck" label="IELTS" name="IELTS" value="IELTS"
                styleClass="checkbox" (onChange)="onEnglishTestCheckboxChange()" />
              <div *ngIf="completeProfileForm.get('testScoreForm.ieltsScoresCheck').value">
                <div class="w_50 mb-2">
                  <p-inputNumber styleClass="input-number" class="w-full"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('testScoreForm.ieltsScores')?.value}"
                    formControlName="ieltsScores" inputId="locale-user" placeholder="Add composite score"
                    [minFractionDigits]="2" />
                </div>
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('testScoreForm.ieltsScores').invalid &&
              (submitted || completeProfileForm.get('testScoreForm.ieltsScores').touched)">
                  IELTS Score is required
                </small>
              </div>
            </div>
            <div class="flex flex-column gap-2">
              <p-checkbox [binary]="true" formControlName="duolingoScoresCheck" label="Duolingo" name="Duolingo"
                value="Duolingo" styleClass="checkbox" (onChange)="onEnglishTestCheckboxChange()" />
              <div *ngIf="completeProfileForm.get('testScoreForm.duolingoScoresCheck').value">
                <div class="w_50 mb-2">
                  <p-inputNumber styleClass="input-number" class="w-full"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('testScoreForm.duolingoScores')?.value}"
                    formControlName="duolingoScores" inputId="locale-user" placeholder="Add composite score"
                    [minFractionDigits]="2" (onChange)="onEnglishTestCheckboxChange()" />
                </div>
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('testScoreForm.duolingoScores').invalid &&
              (submitted || completeProfileForm.get('testScoreForm.duolingoScores').touched)">
                  Duolingo Score is required
                </small>
              </div>
            </div>
            <div class="flex flex-column gap-2">
              <p-checkbox [binary]="true" formControlName="isEnglishProficiencyTestNotGiven"
                label="I haven’t taken any test yet" name="noEnglishTest" value="noEnglishTest" styleClass="checkbox"
                (onChange)="onNoEnglishTestGivenChange($event)" />
            </div>
            <!-- Validation Message -->
            <small class="ng-dirty ng-invalid text-red-500" *ngIf="!(completeProfileForm.get('testScoreForm.toeflScoresCheck').value
            || completeProfileForm.get('testScoreForm.ieltsScoresCheck').value
            || completeProfileForm.get('testScoreForm.duolingoScoresCheck').value
            || completeProfileForm.get('testScoreForm.isEnglishProficiencyTestNotGiven').value) &&
            submitted">
              Please select one of the options
            </small>
          </div>
        </div>
      </div>

    </div>

    <div class="flex-column gap-4 my-5" [ngClass]="{ 'hidden': currentStep != steps.grades}">
      <div class="w-full py-5 yellow_color flex align-items-center justify-content-center">
        <div class="w-full complete_width">
          <h1 class="font-medium text-3xl text-gray-900">Grades</h1>
        </div>
      </div>
      <div class="w-full complete_width mx-auto flex flex-column gap-5 pt-5" formGroupName="grades">
        <div class="flex flex-column gap-3">
          <b class="w-full text-left font-medium text-gray-800 text-base">High school’s grading system <span
              class="text-red-500 text-xl">*</span></b>
          <div class="flex flex-column gap-2">
            <div class="flex flex-column gap-2">
              <p-checkbox label="CGPA" [binary]="true" formControlName="CGPACheck" name="CGPA" value="CGPA"
                (onChange)="toggleGradeValidatorsGeneric('CGPA','CGPAScore', 10, 'HighSchool')" styleClass="checkbox" />
              <div class="w_50 mb-2" *ngIf="completeProfileForm.get('grades.CGPACheck').value">
                <p-inputNumber styleClass="input-number" class="w-full"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('grades.CGPAScore')?.valid}"
                  formControlName="CGPAScore" inputId="locale-user" placeholder="Add score" [minFractionDigits]="2" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades.CGPAScore').invalid &&
                      (submitted || completeProfileForm.get('grades.CGPAScore').touched)">
                  <!-- First Message: CGPA is required -->
                  <ng-container *ngIf="completeProfileForm.get('grades.CGPAScore').hasError('required') &&
                                            (submitted || completeProfileForm.get('grades.CGPAScore').touched)">
                    CGPA is required
                  </ng-container>

                  <!-- Second Message: Invalid CGPA format -->
                  <ng-container *ngIf="completeProfileForm.get('grades.CGPAScore').hasError('lte') &&
                                            !completeProfileForm.get('grades.CGPAScore').hasError('required') &&
                                            (submitted || completeProfileForm.get('grades.CGPAScore').touched)">
                    CGPA must not exceed 10
                  </ng-container>
                </small>
              </div>
            </div>
            <div class="flex flex-column gap-2">
              <p-checkbox binary="true" formControlName="PercentageCheck" label="% on 100" name="% on 100"
                value="% on 100" (onChange)="toggleGradeValidatorsGeneric('Percentage', 'PercentageScore', 100, 'HighSchool')"
                styleClass="checkbox" />
              <div class="w_50 mb-2" *ngIf="completeProfileForm.get('grades.PercentageCheck').value">
                <p-inputNumber styleClass="input-number" class="w-full"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('grades.PercentageScore')?.value}"
                  formControlName="PercentageScore" inputId="locale-user" placeholder="Add score"
                  [minFractionDigits]="2" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades.PercentageScore').invalid &&
                     (submitted || completeProfileForm.get('grades.PercentageScore').touched)">
                  <!-- First Message: CGPA is required -->
                  <ng-container *ngIf="completeProfileForm.get('grades.PercentageScore').hasError('required') &&
                                            (submitted || completeProfileForm.get('grades.PercentageScore').touched)">
                    Percentage is required
                  </ng-container>

                  <!-- Second Message: Invalid CGPA format -->
                  <ng-container *ngIf="completeProfileForm.get('grades.PercentageScore').hasError('lte') &&
                                            !completeProfileForm.get('grades.PercentageScore').hasError('required') &&
                                            (submitted || completeProfileForm.get('grades.PercentageScore').touched)">
                    Percentage must not exceed 100%
                  </ng-container>
                </small>
              </div>
            </div>
            <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades')?.hasError('atLeastOneChecked')
          && submitted">
              <p>Either CGPA or Percentage must be selected.</p>
            </small>
          </div>
        </div>

        <div class="w-full mb-2 flex flex-column gap-2">
          <div class="flex gap-4  flex-column sm:flex-row">
            <div class="flex-1 flex flex-column gap-2">
              <b class="text-sm font-normal text-gray-800">Class Rank <span class="text-red-500 text-xl"></span></b>
              <p-inputNumber [showClear]="true" styleClass="input-number"
                [ngClass]="{'ng-invalid ng-dirty': submitted  && !completeProfileForm.get('grades.classRank')?.value}"
                formControlName="classRank" inputId="integeronly" class="w-full" />
              <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades.classRank').invalid &&
            (submitted || completeProfileForm.get('grades.classRank').touched)">
                Class Rank is required
              </small>
            </div>
            <div class="flex-1 flex flex-column gap-2">
              <b class="text-sm font-normal text-gray-800">Class Size <span class="text-red-500 text-xl"></span></b>
              <p-inputNumber [showClear]="true" styleClass="input-number" [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('grades.classSize')?.value}" formControlName="classSize" inputId="integeronly"
                class="w-full" />
              <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades.classSize').invalid &&
            (submitted || completeProfileForm.get('grades.classSize').touched)">
                Class Size is required
              </small>
            </div>
          </div>
          <small class="ng-dirty ng-invalid text-red-500"
            *ngIf="completeProfileForm.get('grades')?.hasError('classRankLessThanClassSize')">
            <p>Class Rank must be less than Class Size.</p>
          </small>
          <small class="ng-dirty ng-invalid text-red-500"
            *ngIf="completeProfileForm.get('grades')?.hasError('classSizeIsZero')">
            <p>Class Size cannot be zero if Class Rank is greater than zero.</p>
          </small>
          <small class="ng-dirty ng-invalid text-red-500"
            *ngIf="completeProfileForm.get('grades')?.hasError('classRankIsZero')">
            <p>Class Rank cannot be zero if Class Size is greater than zero.</p>
          </small>
          <p class="text-left font-normal text-sm text-gray-500 ">If unsure, add approximate value</p>
        </div>
        
        <div class="flex flex-column gap-3" 
        *ngIf="completeProfileForm.get('demography.highestLevelEducation').value === 'Undergraduate degree' || completeProfileForm.get('demography.highestLevelEducation').value === 'Post Graduate degree'">
          <b class="w-full text-left font-medium text-gray-800 text-base">Undergraduate College Grading System <span
              class="text-red-500 text-xl">*</span></b>
          <div class="flex flex-column gap-2">
            <div class="flex flex-column gap-2">
              <p-checkbox label="CGPA" [binary]="true" formControlName="UnderGraduateCGPACheck" name="CGPA" value="CGPA"
                (onChange)="toggleGradeValidatorsGeneric('CGPA','UnderGraduateCGPAScore', 10, 'UnderGraduate')" styleClass="checkbox" />
              <div class="w_50 mb-2" *ngIf="completeProfileForm.get('grades.UnderGraduateCGPACheck').value">
                <p-inputNumber styleClass="input-number" class="w-full"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('grades.UnderGraduateCGPAScore')?.valid}"
                  formControlName="UnderGraduateCGPAScore" inputId="locale-user" placeholder="Add score" [minFractionDigits]="2" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades.UnderGraduateCGPAScore').invalid &&
                      (submitted || completeProfileForm.get('grades.UnderGraduateCGPAScore').touched)">
                  <!-- First Message: CGPA is required -->
                  <ng-container *ngIf="completeProfileForm.get('grades.UnderGraduateCGPAScore').hasError('required') &&
                                            (submitted || completeProfileForm.get('grades.UnderGraduateCGPAScore').touched)">
                    CGPA is required
                  </ng-container>

                  <!-- Second Message: Invalid CGPA format -->
                  <ng-container *ngIf="completeProfileForm.get('grades.UnderGraduateCGPAScore').hasError('lte') &&
                                            !completeProfileForm.get('grades.UnderGraduateCGPAScore').hasError('required') &&
                                            (submitted || completeProfileForm.get('grades.UnderGraduateCGPAScore').touched)">
                    CGPA must not exceed 10
                  </ng-container>
                </small>
              </div>
            </div>
            <div class="flex flex-column gap-2">
              <p-checkbox binary="true" formControlName="UnderGraduatePercentageCheck" label="% on 100" name="% on 100"
                value="% on 100" (onChange)="toggleGradeValidatorsGeneric('Percentage', 'UnderGraduatePercentageScore', 100, 'UnderGraduate')"
                styleClass="checkbox" />
              <div class="w_50 mb-2" *ngIf="completeProfileForm.get('grades.UnderGraduatePercentageCheck').value">
                <p-inputNumber styleClass="input-number" class="w-full"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('grades.UnderGraduatePercentageScore')?.value}"
                  formControlName="UnderGraduatePercentageScore" inputId="locale-user" placeholder="Add score"
                  [minFractionDigits]="2" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades.UnderGraduatePercentageScore').invalid &&
                     (submitted || completeProfileForm.get('grades.UnderGraduatePercentageScore').touched)">
                  <!-- First Message: CGPA is required -->
                  <ng-container *ngIf="completeProfileForm.get('grades.UnderGraduatePercentageScore').hasError('required') &&
                                            (submitted || completeProfileForm.get('grades.UnderGraduatePercentageScore').touched)">
                    Percentage is required
                  </ng-container>

                  <!-- Second Message: Invalid CGPA format -->
                  <ng-container *ngIf="completeProfileForm.get('grades.UnderGraduatePercentageScore').hasError('lte') &&
                                            !completeProfileForm.get('grades.UnderGraduatePercentageScore').hasError('required') &&
                                            (submitted || completeProfileForm.get('grades.UnderGraduatePercentageScore').touched)">
                    Percentage must not exceed 100%
                  </ng-container>
                </small>
              </div>
            </div>
            <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades')?.hasError('atLeastOneChecked')
          && submitted">
              <p>Either CGPA or Percentage must be selected.</p>
            </small>
          </div>
          <div class="w-full mb-2 flex flex-column gap-2">
            <div class="flex gap-4  flex-column sm:flex-row">
              <div class="flex-1 flex flex-column gap-2">
                <b class="text-sm font-normal text-gray-800">Class Rank</b>
                <p-inputNumber styleClass="input-number"
                  [ngClass]="{'ng-invalid ng-dirty': submitted  && !completeProfileForm.get('grades.UnderGraduateClassRank')?.value}"
                  formControlName="UnderGraduateClassRank" inputId="integeronly" class="w-full" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades.UnderGraduateClassRank').invalid &&
              (submitted || completeProfileForm.get('grades.UnderGraduateClassRank').touched)">
                  Class Rank is required
                </small>
              </div>
              <div class="flex-1 flex flex-column gap-2">
                <b class="text-sm font-normal text-gray-800">Class Size</b>
                <p-inputNumber styleClass="input-number" [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('grades.UnderGraduateClassSize')?.value}" formControlName="UnderGraduateClassSize" inputId="integeronly"
                  class="w-full" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades.UnderGraduateClassSize').invalid &&
              (submitted || completeProfileForm.get('grades.UnderGraduateClassSize').touched)">
                  Class Size is required
                </small>
              </div>
            </div>
            <small class="ng-dirty ng-invalid text-red-500"
              *ngIf="completeProfileForm.get('grades')?.hasError('undergraduateClassRankLessThanClassSize')">
              <p>Class Rank must be less than Class Size.</p>
            </small>
            <small class="ng-dirty ng-invalid text-red-500"
            *ngIf="completeProfileForm.get('grades')?.hasError('classSizeIsZero')">
            <p>Class Size cannot be zero if Class Rank is greater than zero.</p>
          </small>
            <small class="ng-dirty ng-invalid text-red-500"
              *ngIf="completeProfileForm.get('grades')?.hasError('classRankIsZero')">
              <p>Class Rank cannot be zero if Class Size is greater than zero.</p>
            </small>
            <p class="text-left font-normal text-sm text-gray-500 ">If unsure, add approximate value</p>
          </div>

        </div>

        

        <div class="flex flex-column gap-3" *ngIf="completeProfileForm.get('demography.highestLevelEducation').value === 'Post Graduate degree'">
          <b class="w-full text-left font-medium text-gray-800 text-base">Graduate College Grading System <span
              class="text-red-500 text-xl">*</span></b>
          <div class="flex flex-column gap-2">
            <div class="flex flex-column gap-2">
              <p-checkbox label="CGPA" [binary]="true" formControlName="GraduateCGPACheck" name="CGPA" value="CGPA"
                (onChange)="toggleGradeValidatorsGeneric('CGPA','GraduateCGPAScore', 10, 'Graduate')" styleClass="checkbox" />
              <div class="w_50 mb-2" *ngIf="completeProfileForm.get('grades.GraduateCGPACheck').value">
                <p-inputNumber styleClass="input-number" class="w-full"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('grades.GraduateCGPAScore')?.valid}"
                  formControlName="GraduateCGPAScore" inputId="locale-user" placeholder="Add score" [minFractionDigits]="2" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades.GraduateCGPAScore').invalid &&
                      (submitted || completeProfileForm.get('grades.GraduateCGPAScore').touched)">
                  <!-- First Message: CGPA is required -->
                  <ng-container *ngIf="completeProfileForm.get('grades.GraduateCGPAScore').hasError('required') &&
                                            (submitted || completeProfileForm.get('grades.GraduateCGPAScore').touched)">
                    CGPA is required
                  </ng-container>

                  <!-- Second Message: Invalid CGPA format -->
                  <ng-container *ngIf="completeProfileForm.get('grades.GraduateCGPAScore').hasError('lte') &&
                                            !completeProfileForm.get('grades.GraduateCGPAScore').hasError('required') &&
                                            (submitted || completeProfileForm.get('grades.GraduateCGPAScore').touched)">
                    CGPA must not exceed 10
                  </ng-container>
                </small>
              </div>
            </div>
            <div class="flex flex-column gap-2">
              <p-checkbox binary="true" formControlName="GraduatePercentageCheck" label="% on 100" name="% on 100"
                value="% on 100" (onChange)="toggleGradeValidatorsGeneric('Percentage', 'GraduatePercentageScore', 100, 'Graduate')"
                styleClass="checkbox" />
              <div class="w_50 mb-2" *ngIf="completeProfileForm.get('grades.GraduatePercentageCheck').value">
                <p-inputNumber styleClass="input-number" class="w-full"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('grades.GraduatePercentageScore')?.value}"
                  formControlName="GraduatePercentageScore" inputId="locale-user" placeholder="Add score"
                  [minFractionDigits]="2" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades.GraduatePercentageScore').invalid &&
                     (submitted || completeProfileForm.get('grades.GraduatePercentageScore').touched)">
                  <!-- First Message: CGPA is required -->
                  <ng-container *ngIf="completeProfileForm.get('grades.GraduatePercentageScore').hasError('required') &&
                                            (submitted || completeProfileForm.get('grades.GraduatePercentageScore').touched)">
                    Percentage is required
                  </ng-container>

                  <!-- Second Message: Invalid CGPA format -->
                  <ng-container *ngIf="completeProfileForm.get('grades.GraduatePercentageScore').hasError('lte') &&
                                            !completeProfileForm.get('grades.GraduatePercentageScore').hasError('required') &&
                                            (submitted || completeProfileForm.get('grades.GraduatePercentageScore').touched)">
                    Percentage must not exceed 100%
                  </ng-container>
                </small>
              </div>
            </div>
            <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades')?.hasError('atLeastOneChecked')
          && submitted">
              <p>Either CGPA or Percentage must be selected.</p>
            </small>
          </div>

          <div class="w-full mb-2 flex flex-column gap-2">
            <div class="flex gap-4  flex-column sm:flex-row">
              <div class="flex-1 flex flex-column gap-2">
                <b class="text-sm font-normal text-gray-800">Class Rank </b>
                <p-inputNumber styleClass="input-number"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('grades.GraduateClassRank')?.value}"
                  formControlName="GraduateClassRank" inputId="integeronly" class="w-full" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades.GraduateClassRank').invalid &&
              (submitted || completeProfileForm.get('grades.GraduateClassRank').touched)">
                  Class Rank is required
                </small>
              </div>
              <div class="flex-1 flex flex-column gap-2">
                <b class="text-sm font-normal text-gray-800">Class Size </b>
                <p-inputNumber styleClass="input-number" [ngClass]="{'ng-invalid ng-dirty': submitted && !completeProfileForm.get('grades.GraduateClassSize')?.value}" formControlName="GraduateClassSize" inputId="integeronly"
                  class="w-full" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('grades.GraduateClassSize').invalid &&
              (submitted || completeProfileForm.get('grades.GraduateClassSize').touched)">
                  Class Size is required
                </small>
              </div>
            </div>
            <small class="ng-dirty ng-invalid text-red-500"
              *ngIf="completeProfileForm.get('grades')?.hasError('graduateClassRankLessThanClassSize')">
              <p>Class Rank must be less than Class Size.</p>
            </small>
            <small class="ng-dirty ng-invalid text-red-500"
            *ngIf="completeProfileForm.get('grades')?.hasError('classSizeIsZero')">
            <p>Class Size cannot be zero if Class Rank is greater than zero.</p>
          </small>
            <small class="ng-dirty ng-invalid text-red-500"
              *ngIf="completeProfileForm.get('grades')?.hasError('classRankIsZero')">
              <p>Class Rank cannot be zero if Class Size is greater than zero.</p>
            </small>
            <p class="text-left font-normal text-sm text-gray-500 ">If unsure, add approximate value</p>
          </div>

        </div>

        

      </div>
    </div>

    <div class="flex-column gap-4 my-5" [ngClass]="{ 'hidden': currentStep != steps.coursework}">
      <div class="w-full py-5 yellow_color flex align-items-center justify-content-center">
        <div class="w-full complete_width">
          <h1 class="font-medium text-3xl text-gray-900">Coursework</h1>
          <p class="mt-2 text-gray-800">Complete only if applying for undergraduate studies in the US</p>
        </div>
      </div>
      <div class="w-full complete_width mx-auto flex flex-column gap-5 pt-5" formGroupName="courseWork">
        <div>
          <b class="w-full text-left font-medium text-gray-800 text-base">How many classes do you plan to complete by
            the end of senior year (12th grade)?</b>
          <p class="w-full text-left font-normal text-gray-500 text-sm mt-1">Count all classes from 11th to 12th grade.
          </p>
        </div>

        <div class="flex flex-column gap-2">
          <b class="w-full text-left font-medium text-gray-800 text-base">Select Board <span
              class="text-red-500 text-xl">*</span></b>
          <div class="flex flex-column gap-2">
            <p-dropdown [options]="boards" styleClass="full-width"
              [ngClass]="{'ng-invalid ng-dirty' : submitted && ! completeProfileForm.get('courseWork.boardId').value}"
              optionLabel="name" optionValue="id" formControlName="boardId" [filter]="true" filterBy="name"
              [showClear]="true" appendTo="body" (onChange)="onBoardSelection($event)" placeholder="Select Board">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>{{ selectedOption.name }}</div>
                </div>
              </ng-template>
              <ng-template let-board pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ board.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
            <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('courseWork.boardId').invalid &&
               (submitted || completeProfileForm.get('courseWork.boardId').touched)">
              Select Board
            </small>
            <div *ngIf="completeProfileForm.get('courseWork.boardId').value===-1">
              <input type="text" pInputText formControlName="otherBoardName" class="w-full"
                placeholder="Type board name" />
              <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('courseWork.otherBoardName').invalid &&
               (submitted || completeProfileForm.get('courseWork.otherBoardName').touched)">
                Board Name is required
              </small>
            </div>
          </div>
        </div>

        <div class="flex flex-column gap-2">
          <div class="grid w-full">
            <div *ngFor="let subject of subjects;" class="col-12 sm:col-6 md:col-4">
              <p-checkbox formControlName="subjects" [label]="subject.value" [value]="subject.key"
                (onChange)="onSubjectCheck($event,subject.value)" styleClass="checkbox" />
            </div>
            <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('courseWork.subjects').invalid &&
          (submitted || completeProfileForm.get('courseWork.subjects').touched)">
              Subjects are required
            </small>
          </div>
          <div class="w-full" *ngIf="this.completeProfileForm.get('courseWork.subjects').value.includes('Other')">
            <input type="text" formControlName="otherSubjectName" [ngClass]="{'ng-invalid ng-dirty' : (submitted || completeProfileForm.get('courseWork.otherSubjectName').touched)
          &&  completeProfileForm.get('courseWork.otherSubjectName').invalid}" pInputText class="w-full"
              placeholder="Type subject name" />
            <small class="ng-dirty ng-invalid text-red-500" *ngIf="completeProfileForm.get('courseWork.otherSubjectName').invalid &&
           (submitted || completeProfileForm.get('courseWork.otherSubjectName').touched)">
              Other Subject Name is required
            </small>
          </div>
        </div>

        <!-- <div class="flex flex-column gap-2">
          <b class="w-full text-left font-medium text-gray-800 text-base">AP</b>
          <div class="flex gap-2">
            <p-inputNumber formControlName="apTotal" [min]="0" [showButtons]="true" inputId="stacked"
              decrementButtonClass="up" incrementButtonClass="down" styleClass="counter" class="w-full sm:w-auto "
              (onInput)="updateAPSubjectsCourseWork()" />
          </div>
          <div class="flex flex-column gap-2" formArrayName="apSubjects">
            <div *ngFor="let subject of apSubjectsCourseWork.controls; let i = index" class="w-full flex flex-column">
              <input [ngClass]="{'ng-invalid ng-dirty': (submitted || subject.touched) && !subject?.value}" type="text"
                pInputText class="w-full w_50" placeholder="Subject name" [formControlName]="i" />
              <small class="text-red-500" *ngIf="(submitted || subject.touched) && !subject?.value">
                Subject Name is required
              </small>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div class="flex-column gap-4 my-5" [ngClass]="{ 'hidden': currentStep != steps.extracurricular}">
      <div class="w-full py-5 yellow_color flex align-items-center justify-content-center">
        <div class="w-full complete_width">
          <h1 class="font-medium text-3xl text-gray-900">Experiences</h1>
        </div>
      </div>
      <div class="w-full complete_width mx-auto flex flex-column gap-5 pt-5" formGroupName="extraCurricular">
        <div *ngIf="!activitiesLoaded" class="flex align-items-center justify-content-center">
          <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)"
          animationDuration=".5s" />
        </div>
        <div *ngIf="activitiesLoaded" class="flex flex-column gap-4 mt-3" formArrayName="activityDetails">
          <!-- Loop through the form array -->
          <div *ngFor="let item of activityDetails.controls; let i = index" [formGroupName]="i">
            <app-extra-currcular-activity [activities]="activities" [activity]="getActivityGroup(i)" [index]="i" [submitted]="submitted"
             (remove)="removeActivity($event)"></app-extra-currcular-activity>
          </div>
        </div>
        
        <div class="complete_width w-full flex align-items-center justify-content-end">
          <p-button label="Add new activity" styleClass="addbutton_sub" class="w-full sm:w-auto"
            (onClick)="addActivity()" />
        </div>
      </div>
      <div class="w-full complete_width mx-auto flex flex-column gap-5 pt-5">
        <div class="flex flex-column gap-2 p-3 border-round-lg" style="background-color: #f9faea;">
          <b class="w-full text-left font-normal text-gray-800 text-xl">Technical Skills</b>
          <div class="flex flex-column gap-3" formArrayName="technicalSkills">
            <div *ngFor="let item of technicalSkills.controls; let i = index" [formGroupName]="i"
              class="w-full mb-2 flex flex-column gap-2">
              <div class="grid ">
                <div class="flex-1 flex flex-column gap-2 col-5">
                  <b class="text-sm font-normal text-gray-600">Skill Name</b>
                  <input [ngClass]="{'ng-invalid ng-dirty': submitted && !item.get('skillName')?.value}" type="text"
                    formControlName="skillName" pInputText class="w-full" />
                  <small class="text-red-500" *ngIf="item.get('skillName')?.invalid &&
                (submitted || item.get('skillName')?.touched)">
                    Skill Name is required
                  </small>
                </div>
  
                <div class="flex-1 flex flex-column gap-2 col-5">
                  <b class="text-sm font-normal text-gray-600">Description</b>
                  <input [ngClass]="{'ng-invalid ng-dirty': submitted && !item.get('skillDescription')?.value}" type="text"
                    formControlName="skillDescription" pInputText class="w-full" />
                  <small class="text-red-500" *ngIf="item.get('skillDescription')?.invalid &&
                (submitted || item.get('skillDescription')?.touched)">
                    Description is required
                  </small>
                </div>
                <div class="flex justify-content-center align-items-end col-2 pb-3">
                  <p-button icon="pi pi-times" styleClass="closeIcon" [rounded]="true" severity="secondary"
                    (onClick)="removeSkill(i)" />
                </div>
              </div>
            </div>
            
          </div>
        </div>
        <div class="complete_width w-full flex align-items-center justify-content-end">
          <p-button label="Add new skill" styleClass="addbutton_sub" class="w-full sm:w-auto"
            (onClick)="addSkill()" />
        </div>
      </div>

      <div class="w-full complete_width mx-auto flex flex-column gap-5 pt-5">
        <div class="flex flex-column gap-2 p-3 border-round-lg" style="background-color: #f9faea;">
          <b class="w-full text-left font-normal text-gray-800 text-xl">Licenses/Certifications</b>
          <div class="flex flex-column gap-3" formArrayName="licensesAndCertifications">
            <div *ngFor="let item of licensesAndCertifications.controls; let i = index" [formGroupName]="i"
              class="w-full mb-2 flex flex-column gap-2">
              <div class="grid ">
                <div class="flex-1 flex flex-column gap-2 col-5">
                  <b class="text-sm font-normal text-gray-600">License/Certification Name</b>
                  <input [ngClass]="{'ng-invalid ng-dirty': submitted && !item.get('licenseOrCertificationName')?.value}" type="text"
                    formControlName="licenseOrCertificationName" pInputText class="w-full" />
                  <small class="text-red-500" *ngIf="item.get('licenseOrCertificationName')?.invalid &&
                  (submitted || item.get('licenseOrCertificationName')?.touched)">
                    License/Certification Name is required
                  </small>
                </div>
  
                <div class="flex-1 flex flex-column gap-2 col-5">
                  <b class="text-sm font-normal text-gray-600">Issuing Organisation Name</b>
                  <input [ngClass]="{'ng-invalid ng-dirty': submitted && !item.get('issuingOrganisation')?.value}" type="text"
                    formControlName="issuingOrganisation" pInputText class="w-full" />
                  <small class="text-red-500" *ngIf="item.get('issuingOrganisation')?.invalid &&
                  (submitted || item.get('issuingOrganisation')?.touched)">
                    Description is required
                  </small>
                </div>
                <div class="flex-1 flex flex-column gap-2 col-5">
                  <b class="text-sm font-normal text-gray-600">Issuing Date</b>
                  <p-calendar [showIcon]="true" [iconDisplay]="'input'" inputId="iconDisplay"
                    appendTo="body" styleClass="full-width" formControlName="issueDate" /> 
                  <small class="text-red-500" *ngIf="item.get('issueDate')?.invalid &&
                  (submitted || item.get('issueDate')?.touched)">
                    Date is required
                  </small>
                </div>
                <div class="flex justify-content-center align-items-end col-2 pb-3">
                  <p-button icon="pi pi-times" styleClass="closeIcon" [rounded]="true" severity="secondary"
                    (onClick)="removeLicense(i)" />
                </div>
              </div>
            </div>
            
          </div>
        </div>
        <div class="complete_width w-full flex align-items-center justify-content-end">
          <p-button label="Add new License/Certification" styleClass="addbutton_sub" class="w-full sm:w-auto"
            (onClick)="addLicense()" />
        </div>
      </div>

    </div>

      

      <div class="w-full pt-5 flex align-items-center justify-content-center">
      <div class="complete_width w-full flex align-items-center justify-content-center gap-2">
        <p-button *ngIf="this.currentStep>0" label="Back" (onClick)="back()" class="md:w-auto w-full" [outlined]="true"
          styleClass="button_back" />
        <p-button label="CONTINUE" [loading]="this.loading" styleClass="button_sub" (onClick)="continue()"
          class="w-full sm:w-auto" />
      </div>
    </div>
  </form>
</div>
